module.exports = __webpack_public_path__ + "static/recordings-92261cb7d8b0109bd6569d20d4cefd5e.png";